import { render, staticRenderFns } from "./FacetTagMenuCloseButton.vue?vue&type=template&id=4676e01a&"
import script from "./FacetTagMenuCloseButton.vue?vue&type=script&lang=js&"
export * from "./FacetTagMenuCloseButton.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports